import { createReducer, on } from "@ngrx/store";
import { resetAdmissionDate,  setMaxDate, setMinDate } from "./admission-date.action";

export const admissionDateFeatureKey = "admissionDate";

export interface AdmissionDateState {
	minDate;
	maxDate;
}

export const initialState: AdmissionDateState = {
	minDate: undefined,
	maxDate: undefined,
};

export const admissionDateReducer = createReducer(
	initialState,

	on(setMinDate, (state, { data }) => ({
		...state,
		minDate: data,
	})),

	on(setMaxDate, (state, { data }) => ({
		...state,
		maxDate: data,
	})),

	on(resetAdmissionDate, () => initialState)
);
